<template>
    <v-container fluid>
        <div class="pb-3">
            <label>Permission Type:</label>
            <v-autocomplete
                v-model="mainObject.portal_content_type_key"
                :items="permissionOptions"
                item-text="text"
                item-value="value"
                placeholder="No Restrictions"
                clearable
                outlined
                dense
                hide-details
                class="mt-2"
            ></v-autocomplete>
        </div>
    </v-container>
</template>

<script>
/**
 * Defines the level of permissions required by the user to be able to view or edit this section of the page
 */
export default {
    name: 'PortalDesignerPermissions',
    // Object object: The model to display
    // [] permissions: Array of PortalContentType records for the user to choose between
    props: ['object', 'permissions'],
    data () {
        return {
            mainObject: this.object
        }
    },
    computed: {
        permissionOptions() {
            const sorted = [...this.permissions].sort((a, b) => a.text.localeCompare(b.text));
            return [{ text: 'No Restrictions', value: '' }, ...sorted];
        }
    },
    methods: {}
}
</script>
